import React, { useEffect } from "react";
import { Template } from "../../@types/template";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { findTemplate } from "../../store/templateDetail/actions/findTemplate";
import { IonPage, IonHeader, IonContent, IonGrid, IonRow, IonCol, IonItem, IonLabel } from "@ionic/react";
import { Toolbar } from "./components/Toolbar";
import { FileTemplateFormContainer } from "./components/FileTemplateFormContainer";

interface FileTemplateListItemProps {
  template: Template;
}

export const FileTemplateListItem: React.FC<FileTemplateListItemProps> = ({ template }) => {
  const history = useHistory();

  return (
    <IonItem
      button
      onClick={() => history.push(`/app/tic/plantillas-file/detalle/${template.id}`, { state: { template } })}
      class="ion-margin-bottom"
      lines="none"
      detail
    >
      <IonLabel>{template.name}</IonLabel>
    </IonItem>
  );
};
export const FileTemplateDetail: React.FC = () => {
  const { state } = useLocation<{ template?: Template }>();
  const dispatch = useDispatch<any>();
  const { id } = useParams<{ id: string }>();

  const template = state?.template;

  useEffect(() => {
    if (!template && id) {
      dispatch(findTemplate(id));
    }
  }, [template, id, dispatch]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <Toolbar />
      </IonHeader>
      <IonContent fullscreen>
        <IonGrid>
          <IonRow>
            <IonCol>
              <FileTemplateFormContainer template={template} />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
